import equals from 'fast-deep-equal';

import { GroupedAccountCardItem, GroupedItems } from '../../../../../../models/account';

const getStateExtract = (state: GroupedItems<GroupedAccountCardItem>) =>
    state
        .map((group) => ({ name: group.name, values: group.values.map((v) => [v.id, v.favorite]) }))
        .filter((group) => group.values.length !== 0);

export const groupStatesAreNotEqual = (
    stateA: GroupedItems<GroupedAccountCardItem>,
    stateB: GroupedItems<GroupedAccountCardItem>,
) => {
    const essenceOfA = getStateExtract(stateA);
    const essenceOfB = getStateExtract(stateB);
    return !equals(essenceOfA, essenceOfB);
};
